import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userActions from 'src/redux/actions/userActions';
import CustomTable from 'src/components/CustomTable';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import userSelectors from 'src/redux/selectors/userSelectors';
import CustomDate from 'src/components/CustomDate';

const Users = () => {
  const dispatch = useDispatch();
  const loading = useSelector(userSelectors.loading);
  const users = useSelector(userSelectors.users);

  const columns = [
    {
      title: 'Avatar',
      dataIndex: 'avatar',
      width: 100,
      align: 'center',
      render: (value) => <img alt="user's avatar" src={value} style={{ height: 100, aspectRatio: 2 / 3, objectFit: 'contain' }} />
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: 400,
      align: 'center',
      searchable: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: 400,
      align: 'center',
      searchable: true,
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      width: 200,
      align: 'center',
      render: (value) => <CustomDate date={value} />
    },
  ];

  const fetchUsers = () => {
    dispatch(userActions.fetchUsers());
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <CustomTable name="users" columns={columns} loading={loading} data={users} onRefresh={fetchUsers} />
  )
}

export default Users;